import { fixOnlyDateForTable, moneyFormat } from '../../../../../utils/format';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { ToolTipWrap } from '../../Table/ToolTipWrap';
import { SiesaLogIcon } from '../../Table/SiesaLogIcon';

const TerceroInfo = ({ row }) => {
  const getTrimmedValue = (value) => {
    if (value === undefined || value === null) return '';
    return `${value}`.trim();
  };

  const buildEmployeeStatus = (flag) => {
    if (flag === 1) {
      return { isEmployee: true, label: 'Empleado' };
    }

    if (flag === 0) {
      return { isEmployee: false, label: 'Externo' };
    }

    return { isEmployee: false, label: '...' };
  };

  const ConductorLabel = ({ status }) => {
    const isEmployee = status?.isEmployee ?? false;
    const label = status?.label ?? '...';

    return <span className={`${isEmployee ? 'text-green-600' : 'text-red-600'} `}>{`${label} `}</span>;
  };

  const AparejadorLabel = ({ data }) => {
    const status = buildEmployeeStatus(data.APAREJADOR_ES_EMPLEADO);
    return <span className={`${status.isEmployee ? 'text-green-600' : 'text-red-600'} `}>{`${status.label || '...'} `}</span>;
  };

  const getConductorDisplayData = (data) => {
    const isExternalVehicle = Number(data.V_VEHICULO_PROPIO) === 0;
    const beneficiaryDoc = getTrimmedValue(data.BENEFICIARIO_DOC);
    const conductorDoc = getTrimmedValue(data.CONDUCTOR_DOC);
    const tenedorDoc = getTrimmedValue(data.V_TERCERO_TENEDOR_DOCUMENTO);
    const hasBeneficiaryDoc = beneficiaryDoc !== '';
    const isOwnVehicle = !isExternalVehicle;

    let displayName = getTrimmedValue(data.CONDUCTOR_NOMBRE) || data.CONDUCTOR_NOMBRE;
    let displayDocument = conductorDoc;
    let isProvider = false;
    let employeeStatus = buildEmployeeStatus(data.CONDUCTOR_ES_EMPLEADO);

    if (hasBeneficiaryDoc) {
      displayName = getTrimmedValue(data.BENEFICIARIO_NOMBRE) || displayName;
      displayDocument = beneficiaryDoc;
      employeeStatus = buildEmployeeStatus(data.BENEFICIARIO_ES_EMPLEADO);
      const isBeneficiaryDifferentFromTenedor = tenedorDoc !== '' && beneficiaryDoc !== tenedorDoc;
      const isBeneficiarySameAsConductor = conductorDoc !== '' && beneficiaryDoc === conductorDoc;

      if (isBeneficiaryDifferentFromTenedor && (!isOwnVehicle || !isBeneficiarySameAsConductor)) {
        isProvider = true;
      }
    } else if (isExternalVehicle) {
      displayName = getTrimmedValue(data.V_TERCERO_TENEDOR_NOMBRE) || displayName;
      displayDocument = tenedorDoc || displayDocument;
    }

    return {
      displayName,
      displayDocument,
      isProvider,
      employeeStatus,
    };
  };

  if (row.SOLICITUD_ANTICIPO_TIPO === 'C') {
    const conductorDisplay = getConductorDisplayData(row);

    return (
      <>
        {/* <td className="whitespace-nowrap px-2   text-left">C</td> */}
        <td className=" px-2   text-left">
          <div className="flex flex-col">
            <span>
              C.&nbsp;
              {conductorDisplay.displayName?.substring(0, 40)} <ConductorLabel status={conductorDisplay.employeeStatus} />
              {conductorDisplay.isProvider && (
                <span className="ml-1 text-xs font-semibold text-blue-600">Proveedor</span>
              )}
            </span>
            {conductorDisplay.displayDocument && (
              <span className="text-[10px] text-gray-500">Doc: {conductorDisplay.displayDocument}</span>
            )}
          </div>
        </td>
        <td className=" px-2   text-right">{moneyFormat(row.CONDUCTOR_VALOR)}</td>
      </>
    );
  }

  return (
    <>
      {/* <td className="whitespace-nowrap px-2   text-left">A</td> */}
      <td className="whitespace-nowrap px-2   text-left">
        A.&nbsp;
        {row.APAREJADOR_NOMBRE?.substring(0, 40)} <AparejadorLabel data={row} />
      </td>
      <td className="whitespace-nowrap px-2   text-right">{moneyFormat(row.APAREJADOR_VALOR)}</td>
    </>
  );
};

const NoteIcon = ({ row }) => {
  const color = '';

  return (
    <ToolTipWrap
      itemID={row.SOLICITUD_ANTICIPO_ID}
      componentPrefix={'tooltipNoteIcon'}
      message={row.SOLICITUD_ANTICIPO_OBSERVACION}>
      <InformationCircleIcon
        data-tip
        data-for={`tooltipNoteIcon${row.SOLICITUD_ANTICIPO_ID}`}
        className={`hover:fill-blue-500 h-5 w-5 transform cursor-pointer ${color} transition duration-300 hover:scale-110`}
      />
    </ToolTipWrap>
  );
};

export const TableVehiculoAnticipoTbody = ({ data, endPoint, actions }) => {
  const fases = ['', 'Financiera', 'Gerencia'];

  // const { resendSiesaAnticipo } = endPoint;
  const { refrestVehiculoAnticipos, handleShowSiesaLog } = actions;

  return (
    <tbody className="">
      {data?.map((obj) => (
        <tr
          key={obj.SOLICITUD_ANTICIPO_ID}
          className="border-b text-xs">
          <td className="px-2 text-green-400">{obj.SOLICITUD_ANTICIPO_ID}</td>
          <td className="whitespace-nowrap px-2   text-right">{fixOnlyDateForTable(obj.CREATED_AT)}</td>
          <td className="whitespace-nowrap px-2   text-left">{obj.SOLICITUD_ANTICIPO_CONSECUTIVO}</td>
          <td className="whitespace-nowrap px-2   text-left">{fases[obj.SOLICITUD_ANTICIPO_FASE].substring(0, 3)}</td>
          <td className="whitespace-nowrap px-2   text-right">{moneyFormat(obj.SOLICITUD_ANTICIPO_TOTAL)}</td>
          <td className="whitespace-nowrap px-2   text-right">{moneyFormat(obj.SOLICITUD_ANTICIPO_VALOR)}</td>

          <TerceroInfo row={obj} />

          {/* <td className="px-2text-left">{`${obj.TARIFA_GRUPO} ${obj.TARIFA_NOMBRE}`}</td> */}
          <td className=" px-2   text-left">{obj.TERCERO_NOMBRE_BUSQUEDA?.substring(0, 40)}</td>
          <td className=" px-2   text-left">
            <NoteIcon row={obj} />
          </td>

          <td className="whitespace-nowrap px-2   text-left">
            <SiesaLogIcon
              row={obj}
              itemID={obj.SOLICITUD_ANTICIPO_ID}
              consecutivoField="SOLICITUD_ANTICIPO_CONSECUTIVO"
              responseField="SOLICITUD_EXT_RESPUESTA"
              onIconClick={(row, isSendFail) => handleShowSiesaLog(row, isSendFail, refrestVehiculoAnticipos)}
              tooltipPrefix="tooltipSiesaLog"
            />
          </td>
          {/* <td
            className="cursor-pointer px-4 py-3 text-left hover:text-gray-400"
            onClick={() => handleClick(item.SOLICITUD_DETALLE_ID)}>
            <Trash />
          </td> */}
        </tr>
      ))}
    </tbody>
  );
};
